import ProductSettings from "../productSettings/ProductSettings";
import { Box } from "@mui/material";

const ProductsList = ({marketId, products}) => {
    return (
        <Box
            sx={{
                marginBottom: "100px"
            }}
        >
            {products.map((product) => (
                <ProductSettings
                    key={product.productId}
                    product={product}
                    marketId={marketId}
                />
            ))}
        </Box>
    );
};

export default ProductsList;
